// Collapsible basado en <details> HTML nativo. Accesible por default, sin JS
// para el toggle.
//
//   <Collapsible label="Mis horas del turno" defaultOpen>
//     ...contenido...
//   </Collapsible>

import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface CollapsibleProps {
  label: ReactNode;
  /** Contenido extra al lado del label (ej. badge con contador). */
  trailing?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
  className?: string;
}

export function Collapsible({
  label,
  trailing,
  defaultOpen = false,
  children,
  className,
}: CollapsibleProps) {
  return (
    <details
      open={defaultOpen}
      className={cn('group rounded border border-border bg-surface-elevated', className)}
    >
      <summary className="flex cursor-pointer list-none items-center justify-between gap-2 px-4 py-3 text-sm font-medium text-fg select-none [&::-webkit-details-marker]:hidden">
        <span className="flex items-center gap-2">
          <ChevronRightIcon className="size-4 text-fg-tertiary transition-transform group-open:rotate-90" />
          {label}
        </span>
        {trailing}
      </summary>
      <div className="border-t border-border p-4">{children}</div>
    </details>
  );
}

function ChevronRightIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      <path d="m9 18 6-6-6-6" />
    </svg>
  );
}
